// Central test-id constants for PropHR
export const TID = {
  // Landing
  landingHero: "landing-hero",
  landingLogin: "landing-login-btn",
  landingRegister: "landing-register-btn",

  // Auth
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginRegisterLink: "login-register-link",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerTenant: "register-tenant-slug-input",
  registerSubmit: "register-submit-btn",

  // Nav
  navHome: "nav-home",
  navCases: "nav-cases",
  navCreate: "nav-create-case",
  navUsers: "nav-users",
  navTenants: "nav-tenants",
  navPolicies: "nav-policies",
  navAudit: "nav-audit",
  navGodMode: "nav-enterprise-intelligence",
  navAnalytics: "nav-analytics",
  navLogout: "nav-logout-btn",

  // Cases
  createCaseTitle: "create-case-title",
  createCaseDescription: "create-case-description",
  createCaseCategory: "create-case-category",
  createCasePriority: "create-case-priority",
  createCaseAnonymous: "create-case-anonymous-toggle",
  createCaseSubmit: "create-case-submit-btn",
  createCaseFileInput: "create-case-file-input",
  createCaseRecordVoice: "create-case-record-voice-btn",
  createCaseStopVoice: "create-case-stop-voice-btn",
  createCaseUploadReason: "create-case-upload-reason",

  caseCard: (id) => `case-card-${id}`,
  caseStatus: (id) => `case-status-${id}`,
  caseDetail: "case-detail",
  caseCommentInput: "case-comment-input",
  caseCommentSubmit: "case-comment-submit",
  caseAssignHr: "case-assign-hr",
  caseChangeStatus: "case-change-status",
  caseUploadEvidenceInput: "case-upload-evidence-input",
  caseUploadEvidenceBtn: "case-upload-evidence-btn",
  caseEvidenceReason: "case-evidence-reason-input",
  caseFindingsBtn: "case-findings-btn",
  caseFindingsApprove: "case-findings-approve-btn",
  caseFindingsReject: "case-findings-reject-btn",
  caseAIReanalyze: "case-ai-reanalyze",
  caseDualPerspective: "case-dual-perspective-btn",
  caseSentinelToggle: "case-sentinel-toggle",

  // Super admin
  createTenantBtn: "create-tenant-btn",
  createTenantSubmit: "create-tenant-submit",
  godModeRunBtn: "enterprise-intelligence-run-btn",

  // Company admin
  createUserBtn: "create-user-btn",
  createUserSubmit: "create-user-submit",

  // Profile / settings
  profileSave: "profile-save-btn",
  profileName: "profile-name-input",
  profileAvatarInput: "profile-avatar-input",
  passwordCurrent: "password-current-input",
  passwordNew: "password-new-input",
  passwordSubmit: "password-submit-btn",

  // Policies
  policyCreateBtn: "policy-create-btn",
  policyName: "policy-name-input",
  policyCategory: "policy-category-input",
  policySave: "policy-save-btn",
  policySubmit: "policy-submit-btn",
  policyApprove: "policy-approve-btn",
  policyReject: "policy-reject-btn",
  policyAcknowledgeName: "policy-ack-name-input",
  policyAcknowledgeAgree: "policy-ack-agree-checkbox",
  policyAcknowledgeSubmit: "policy-ack-submit-btn",

  // Wizard - CreateCase steps
  wizardNext: "wizard-next-btn",
  wizardBack: "wizard-back-btn",
  wizardStep: (n) => `wizard-step-${n}`,
  createCaseLegalSignature: "create-case-legal-signature-input",
  createCaseAckTruthful: "create-case-ack-truthful-checkbox",
  createCaseIncidentDate: "create-case-incident-date",
  createCaseRecurrence: "create-case-recurrence",
  createCaseImpact: "create-case-impact",
  createCaseLocation: "create-case-location",
  createCaseRequestedOutcome: "create-case-requested-outcome",
  createCasePriorReports: "create-case-prior-reports",
  createCaseAnonDisclaimerAgree: "create-case-anon-disclaimer-agree",

  // Workflows
  workflowCreateBtn: "workflow-create-btn",
  workflowName: "workflow-name-input",
  workflowSave: "workflow-save-btn",
  workflowAddStep: "workflow-add-step-btn",
  workflowClone: (id) => `workflow-clone-${id}`,

  // Company profile
  cpNext: "company-profile-next",
  cpSave: "company-profile-save",
  cpLegalName: "cp-legal-name",
  cpWebsite: "cp-website",
  cpLogoInput: "cp-logo-input",

  // Billing
  billingUpgradeBtn: (plan) => `billing-upgrade-${plan}`,
  billingInvoiceDownload: (id) => `billing-invoice-download-${id}`,

  // Tickets
  ticketCreateBtn: "ticket-create-btn",
  ticketSubject: "ticket-subject-input",
  ticketDescription: "ticket-description-input",
  ticketSubmit: "ticket-submit-btn",
  ticketReplyInput: "ticket-reply-input",
  ticketReplySubmit: "ticket-reply-submit-btn",

  // Terms modal
  termsAgreeCheckbox: "terms-agree-checkbox",
  termsAcceptBtn: "terms-accept-btn",

  // Case detail
  caseWithdrawBtn: "case-withdraw-btn",
  caseWithdrawReason: "case-withdraw-reason",
  caseWithdrawAck: "case-withdraw-ack",
  caseWithdrawConfirm: "case-withdraw-confirm",
  caseCommentInternal: "case-comment-internal",
  reporterProfileTrigger: "reporter-profile-trigger",
  reporterProfileModal: "reporter-profile-modal",
};

export default TID;
